import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumSkeleton, CriteriumScreenshots } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const MobileRendering = ({ criterium }) => {
  const { data } = criterium;
  const { variant } = useReviewContext();

  return (
    <Criterium criterium={criterium}>
      {variant === 'nocrit' ? <CriteriumSkeleton variant='circle' width='30%' style={{ height: '200px', margin: 'auto' }} /> : <CriteriumScreenshots {...data} />}
    </Criterium>
  );
};

MobileRendering.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      phone: PropTypes.string,
      tablet: PropTypes.string
    })
  })
};

export default React.memo(MobileRendering);
